/* eslint-disable no-undef */
import axios from 'axios'
import { userAgent } from '@/helpers'

axios.defaults.headers.common['UserAgent'] = userAgent()

let setToken = async token => {
	axios.defaults.headers.common['Authorization'] = `${token}`;
};

const login = (data) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.individual}/Authentication/Authenticate`, data)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const sms = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.individual}/Authentication/ValidateOTP`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const insurances = async (form, token) => {
	await setToken(token);
	return new Promise((resolve, reject) => {
		return axios.get(`${_api.individual}/Agito/api/Customer/${form.CustomerId}/summary`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const contracts = async (form, token) => {
	await setToken(token);
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.individual}/CustomerPolicies/GetCustomerPoliciess`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const resendSms = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.individual}/Authentication/SendOTP`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const forget = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.individual}/Authentication/ResetForgottenPassword`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const changeForgettenPassword = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.individual}/Authentication/ChangeForgottenPassword`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const register = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.individual}/Authentication/Register`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const createPassword = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.individual}/Authentication/CreatePassword`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const validateCaptcha = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.individual}/Authentication/validateCaptcha`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const serviceControl = () => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.individual}/Authentication/ServiceControl`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
export { login, sms, insurances, contracts, resendSms, forget, changeForgettenPassword, register, createPassword,validateCaptcha,serviceControl }